import type { RouteRecordRaw } from 'vue-router'

export const portalRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('@/layout/portal/index.vue'),
    meta: { isPortal: true },
    children: [
      {
        path: '',
        name: 'PortalHome',
        component: () => import('@/views/portal/home/index.vue'),
        meta: { title: '首页', public: true }
      },
      {
        path: 'login',
        name: 'PortalLogin',
        component: () => import('@/views/portal/login/index.vue'),
        meta: { title: '登录', public: true }
      },
      // 案件管理
      {
        path: 'debts',
        name: 'PortalDebts',
        component: () => import('@/views/portal/debts/index.vue'),
        meta: { title: '债务大厅', public: true }
      },
      {
        path: 'debts/:id',
        name: 'PortalDebtDetail',
        component: () => import('@/views/portal/debts/detail.vue'),
        meta: { title: '案件详情', public: true }
      },
      {
        path: 'debts/:id/plans',
        name: 'PortalDebtPlans',
        component: () => import('@/views/portal/plans/index.vue'),
        meta: { title: '调解方案', public: true }
      },
      {
        path: 'debts/:id/settlement',
        name: 'PortalSettlement',
        component: () => import('@/views/portal/settlement/index.vue'),
        meta: { title: '结算', public: false }
      },
      {
        path: 'publish',
        name: 'PortalPublish',
        component: () => import('@/views/portal/publish/index.vue'),
        meta: { title: '发布案件', public: false }
      },
      {
        path: 'my-debts',
        name: 'PortalMyDebts',
        component: () => import('@/views/portal/my-debts/index.vue'),
        meta: { title: '我的发布', public: false }
      },
      {
        path: 'my-progress',
        name: 'PortalMyProgress',
        component: () => import('@/views/portal/my-progress/index.vue'),
        meta: { title: '我的进度', public: false }
      },
      // 钱包财务
      {
        path: 'wallet',
        name: 'PortalWallet',
        component: () => import('@/views/portal/wallet/index.vue'),
        meta: { title: '我的钱包', public: false }
      },

      {
        path: 'wallet/vouchers',
        name: 'PortalVouchers',
        component: () => import('@/views/portal/wallet/vouchers.vue'),
        meta: { title: '发布券', public: false }
      },
      {
        path: 'wallet/buy-voucher',
        name: 'PortalBuyVoucher',
        component: () => import('@/views/portal/wallet/buy-voucher.vue'),
        meta: { title: '购买发布券', public: false }
      },
      // 会员
      {
        path: 'member',
        name: 'PortalMember',
        component: () => import('@/views/portal/member/index.vue'),
        meta: { title: '会员中心', public: false }
      },
      {
        path: 'member/upgrade',
        name: 'PortalMemberUpgrade',
        component: () => import('@/views/portal/member/upgrade.vue'),
        meta: { title: '会员升级', public: false }
      },
      {
        path: 'partner/upgrade',
        name: 'PortalPartnerUpgrade',
        component: () => import('@/views/portal/member/partner-upgrade.vue'),
        meta: { title: '合伙人升级', public: false }
      },
      // 信息公告
      {
        path: 'info',
        name: 'PortalInfo',
        component: () => import('@/views/portal/info/index.vue'),
        meta: { title: '信息大厅', public: true }
      },
      {
        path: 'info/:id',
        name: 'PortalInfoDetail',
        component: () => import('@/views/portal/info/detail.vue'),
        meta: { title: '信息详情', public: true }
      },
      {
        path: 'notices',
        name: 'PortalNotices',
        component: () => import('@/views/portal/notices/index.vue'),
        meta: { title: '公告', public: true }
      },
      {
        path: 'notices/:id',
        name: 'PortalNoticeDetail',
        component: () => import('@/views/portal/notice-detail/index.vue'),
        meta: { title: '公告详情', public: true }
      },
      // 经办人
      {
        path: 'mediator/apply',
        name: 'PortalMediatorApply',
        component: () => import('@/views/portal/mediator/apply.vue'),
        meta: { title: '经办人入驻', public: true }
      },
      {
        path: 'mediator/tasks',
        name: 'PortalMediatorTasks',
        component: () => import('@/views/portal/mediator/tasks.vue'),
        meta: { title: '我的任务', public: false }
      },
      {
        path: 'mediator/tasks/:id',
        name: 'PortalMediatorTaskDetail',
        component: () => import('@/views/portal/mediator/task-detail.vue'),
        meta: { title: '任务详情', public: false }
      },
      {
        path: 'mediator/plan',
        name: 'PortalMediatorPlan',
        component: () => import('@/views/portal/mediator-plan/index.vue'),
        meta: { title: '提交方案', public: false }
      },
      {
        path: 'mediator/profile',
        name: 'PortalMediatorProfile',
        component: () => import('@/views/portal/mediator/profile.vue'),
        meta: { title: '经办人档案', public: false }
      },
      // 设置
      {
        path: 'settings',
        name: 'PortalSettings',
        component: () => import('@/views/portal/settings/index.vue'),
        meta: { title: '账号设置', public: false }
      },
      // 邀请
      {
        path: 'invite',
        name: 'PortalInvite',
        component: () => import('@/views/portal/invite/index.vue'),
        meta: { title: '邀请好友', public: false }
      },
      {
        path: 'invite/list',
        name: 'PortalInviteList',
        component: () => import('@/views/portal/invite/list.vue'),
        meta: { title: '邀请记录', public: false }
      },
      // 佣金
      {
        path: 'commission',
        name: 'PortalCommission',
        component: () => import('@/views/portal/commission/index.vue'),
        meta: { title: '佣金记录', public: false }
      },
      // 搜索
      {
        path: 'search',
        name: 'PortalSearch',
        component: () => import('@/views/portal/search/index.vue'),
        meta: { title: '搜索', public: true }
      },
      // 支付成功
      {
        path: 'pay-success',
        name: 'PortalPaySuccess',
        component: () => import('@/views/portal/pay-success/index.vue'),
        meta: { title: '支付成功', public: true }
      },
      // 404
      {
        path: ':pathMatch(.*)*',
        name: 'PortalNotFound',
        component: () => import('@/views/portal/not-found/index.vue'),
        meta: { title: '页面不存在', public: true }
      },
      // 个人中心 & 其他
      {
        path: 'profile',
        name: 'PortalProfile',
        component: () => import('@/views/portal/profile/index.vue'),
        meta: { title: '个人中心', public: false }
      },
      {
        path: 'checkout',
        name: 'PortalCheckout',
        component: () => import('@/views/portal/checkout/index.vue'),
        meta: { title: '收银台', public: false }
      },
      {
        path: 'ecology',
        name: 'PortalEcology',
        component: () => import('@/views/portal/ecology/index.vue'),
        meta: { title: '生态入驻', public: true }
      },
    ]
  }
]
